import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function CarvedAnimalsPage() {
  return <ProductPageContent data={PRODUCT_PAGES["carved-animals"]} />;
}

export default CarvedAnimalsPage;
